/**
 * Lumi motion core. Components register their animations here and this
 * file decides whether and how they run:
 *   desktop: no reduced motion, wide screen, fine pointer
 *   touch:   no reduced motion, narrower screens or coarse pointers
 *   reduced motion or motion disabled in theme settings: nothing runs
 *
 * Registrations today: the section heading reveal (assets/home.js), the cart drawer settle
 * (assets/cart.js) and the filter grid (Flip, assets/facets.js).
 *
 * Usage: Lumi.motion.register('name', ({ desktop, touch }) => { ...; return cleanup; });
 */
(function () {
  const Lumi = (window.Lumi = window.Lumi || {});
  const queue = [];
  let mm = null;

  const enabled = () => document.documentElement.dataset.motion !== 'false';

  function run(name, setup) {
    if (!window.gsap || !mm) return;
    mm.add(
      {
        desktop: '(prefers-reduced-motion: no-preference) and (min-width: 990px) and (pointer: fine)',
        touch: '(prefers-reduced-motion: no-preference) and ((max-width: 989px) or (pointer: coarse))',
      },
      (context) => {
        const { desktop, touch } = context.conditions;
        if (!desktop && !touch) return undefined;
        try {
          return setup({ desktop, touch, context });
        } catch (err) {
          console.warn(`[Lumi motion] ${name} failed`, err);
          return undefined;
        }
      }
    );
  }

  Lumi.motion = {
    ready: false,
    register(name, setup) {
      if (!enabled()) return;
      if (Lumi.motion.ready) run(name, setup);
      else queue.push([name, setup]);
    },
  };

  function boot() {
    if (!window.gsap || !enabled()) return;
    if (window.Flip) window.gsap.registerPlugin(window.Flip);
    if (window.SplitText) window.gsap.registerPlugin(window.SplitText);
    window.gsap.defaults({ ease: 'power3.out', duration: 0.8 });
    mm = window.gsap.matchMedia();
    Lumi.motion.ready = true;
    queue.splice(0).forEach(([name, setup]) => run(name, setup));
  }

  // Scripts are deferred: gsap has executed before this file.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
